// extracted by mini-css-extract-plugin
module.exports = {"cardDescriptionProductContainer":"nrF0T","cardDescriptionProduct":"_3BSM1","titleMobile":"_2GgsO","titleDesktop":"dzxoK","active":"NDAxl"};